import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { CommsStore } from "@store/comms";
import { CommSend } from "@models/comm-send";
import { CommReceipt } from "@models/comm-receipt";
import { CommReceiptsIndexParams, FetchCommSendsParams } from "@services/comm";
import {
  FETCH_COMM_SENDS,
  FETCH_COMM_RECEIPTS
} from "@reducers/comms";
import { COMM_OF_TYPES } from "@constants/comms";

@Component({
  selector: 'comms-sends-view',
  templateUrl: './comms-sends-view.pug',
})
export class CommsSendsViewComponent implements OnInit, OnDestroy {

  @Input() public mode: string = "email"

  public commSends: CommSend[] = []
  public commReceipts: CommReceipt[] = []

  public sanatizedTemplateBodyHtml: any = null

  private commsSubscription: Subscription


  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private htmlSanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.commsSubscription =
      this.store.select("commsReducer")
        .subscribe((s: CommsStore) => {
          this.commSends       = s.commSends
          this.commReceipts    = s.commReceipts
        })

    this.initialSetup()
  }

  initialSetup() {
    let typeOf: number

    switch (this.mode) {
      case "email": {
        typeOf = COMM_OF_TYPES.Email
        break
      }
      case "sms": {
        typeOf = COMM_OF_TYPES.Sms
        break
      }
    }
    const payload: FetchCommSendsParams = { type_of: typeOf }

    this.store.dispatch({ type: FETCH_COMM_SENDS, payload })
  }

  clickedCommSend(cs: CommSend) {
    if (cs.isShowingEmailReceipts) {
      cs.isShowingEmailReceipts = false
    }
    else {
      this.commSends.forEach((cs) => cs.isShowingEmailReceipts = false)
      cs.isShowingEmailReceipts = true

      this.sanatizedTemplateBodyHtml =
        this.htmlSanitizer.bypassSecurityTrustResourceUrl(`data:text/html;charset=utf-8,${cs.messageBody}`)

      const payload: CommReceiptsIndexParams = { comm_send_id: cs.id }
      this.store.dispatch({ type: FETCH_COMM_RECEIPTS, payload })
    }
  }

  isEmailPreviewShowing(): boolean {
    return this.mode == "email" && !!this.sanatizedTemplateBodyHtml
  }

  ngOnDestroy() {
    this.commsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/comms-sends-view.ts